/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import { Box, Typography } from '@mui/material'
const NotFound = () => {
    return (
        <>
            <Box>
                <Box>
                    <img src="/assets/images/newimages/notification.png" style={{ display: 'flex', margin: 'auto' }} />
                </Box>
                <Box sx={{
                    textAlign: 'center', marginTop: '20px'
                }}>
                    <Typography sx={{ color: '#1A1F36', fontSize: '22px', fontWeight: '600' }}>
                        No notification
                    </Typography>
                    <Typography sx={{ color: '#373737', fontSize: '14px', fontWeight: '400' }}>
                        You’re all caught up! Notifications about activity, updates, or approvals will show up here.
                    </Typography>
                </Box>
            </Box>

        </>
    )
}
export default NotFound